import ComponentRegistry from "Fratello/Common/ComponentRegistry";

// Atoms
import Choice from "Fratello/Atoms/Choice";
import Dropdown from "Fratello/Atoms/Dropdown";
import MultiCheckbox from "../Atoms/MultiCheckbox";
import Image from "../Atoms/Image";
import ImagePlaceholder from "../Atoms/ImagePlaceholder";
import DeleteButton from "Fratello/Atoms/DeleteButton";
import Price from "Fratello/Atoms/Price";
//import Price from "../Atoms/Price";
import Slider from "Fratello/Atoms/Slider";

// Atoms
ComponentRegistry.register({Choice});
ComponentRegistry.register({Dropdown});
ComponentRegistry.register({MultiCheckbox});
ComponentRegistry.register({Image});
ComponentRegistry.register({ImagePlaceholder});
ComponentRegistry.register({DeleteButton});
ComponentRegistry.register({Price});
ComponentRegistry.register({Slider});



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Components/Atoms.jsx